__turbopack_context__.v({
  "root": "number-ticker-module__3FUAjG__root",
});
